import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CreateTicketForm from '../components/tickets/CreateTicketForm';
import { CreateTicketFormData } from '../types/ticket';
import DashboardLayout from '../components/layout/DashboardLayout';
import Container from '../components/layout/Container';
import { useAuthContext } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

// Extended interface for ticket data with form template fields
interface TicketData extends CreateTicketFormData {
  id: number;
  form_template_id?: number;
  form_response?: any;
  [key: string]: any;
}

export default function CreateTicketPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const { user } = useAuthContext();
  const { theme } = useTheme();
  const { t } = useTranslation();

  const handleSubmit = async (data: TicketData) => {
    try {
      if (user) {
        data.updatedById = user.id;
      }
      navigate(`/tickets/${data.id}`);
    } catch (err) {
      setError(t('pages.createTicket.error'));
      console.error('Error creating ticket:', err);
    }
  };

  const handleCancel = () => {
    navigate('/tickets');
  };

  return (
    <DashboardLayout>
      <Container className="py-6 mb-6">
        <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow`}>
          <div>
            <div className="p-4 border-b">
              <div className={`${error && 'mb-4'}`}>
                <h1
                  className={`text-2xl font-semibold ${
                    theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
                  }`}
                >
                  {t('pages.createTicket.title')}
                </h1>
                <p className="text-sm text-muted-foreground mt-0.5">
                  {t('pages.createTicket.description')}
                </p>
              </div>
              {error && (
                <div
                  className={`mb-4 px-4 py-3 rounded-lg ${
                    theme === 'dark'
                      ? 'bg-red-900/50 border-red-800 text-red-200'
                      : 'bg-red-50 border border-red-200 text-red-600'
                  }`}
                >
                  {error}
                </div>
              )}
            </div>
            <CreateTicketForm onSubmit={handleSubmit} onCancel={handleCancel} />
          </div>
        </div>
      </Container>
    </DashboardLayout>
  );
}
